import React from 'react';
import "hammerjs";
import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartValueAxis,
    ChartCategoryAxis,
    ChartValueAxisItem,
    ChartCategoryAxisItem
  } from '@progress/kendo-react-charts';

import ReportTooltip from './ReportTooltip';

const DailyPublishedBudgetChart = ({dailyPublishedBudget}) => {
    return (
        <div className='daily-published-budget-container'>
            <div className='report-chart-title'>
                <h3 className='font-secondary font-weight-500 font-size-18 text-color-dark'>Published Budget</h3>
                <ReportTooltip description={'Your daily sponsorship publication progress'}/>
            </div>    
            <div className ='daily-published-budget-chart'>
                <Chart
                    style={{
                    height: 300
                    }}
                    pannable={{
                        lock: "y"
                      }}
                      zoomable={{
                        mousewheel: {
                          lock: "y"
                        }
                      }}
                >
                    <ChartSeries>
                        <ChartSeriesItem
                        color="#BB61C2"
                        key="daily"
                        type="line"
                        tooltip={{
                            visible: true,
                            format:"c0"
                        }}
                        field='publishedDailyBudget'
                        categoryField="publishedDate"
                        data={dailyPublishedBudget}
                        />
                    </ChartSeries>
                    <ChartCategoryAxis>
                    <ChartCategoryAxisItem
                        labels={{
                            rotation: "auto",
                            format: "{0:MMM dd}"
                          }}
                        title={{text:"Days"}}/>
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                    <ChartValueAxisItem
                        title={{
                        text: "Cumulative Published"
                        }}
                        labels={{
                            format: "c0"
                          }}
                    />
                     </ChartValueAxis>


                 </Chart>

            </div>

        </div>
    );
};

export default DailyPublishedBudgetChart;
